// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZLGt","type":"styles_type__ZWwD9","choices":"styles_choices__VY-pV"};